import type { CreatorStatus } from '@/types';

export type PipelineColumn = {
  status: CreatorStatus;
  label: string;
  color: string;
};

export const PIPELINE_COLUMNS: PipelineColumn[] = [
  { status: 'new', label: 'Nuevo', color: 'text-text-tertiary' },
  { status: 'contacted', label: 'Contactado', color: 'text-info' },
  { status: 'negotiating', label: 'Negociando', color: 'text-warning' },
  { status: 'closed_won', label: 'Cerrado', color: 'text-success' },
  { status: 'closed_lost', label: 'Perdido', color: 'text-error' },
  { status: 'promotion', label: 'Promo', color: 'text-brand-red' },
];

export const VALID_TRANSITIONS: Record<CreatorStatus, CreatorStatus[]> = {
  new: ['contacted'],
  contacted: ['negotiating'],
  negotiating: ['closed_won', 'closed_lost'],
  closed_won: ['promotion'],
  closed_lost: [],
  promotion: [],
};
